// extracted by mini-css-extract-plugin
export var addButton = "_ir-0";
export var border = "_ir-8";
export var check = "_ir-h";
export var danger = "_ir-6";
export var dropdownContainer = "_ir-1";
export var editModalBody = "_ir-j";
export var footerContainer = "_ir-i";
export var fullWidth = "_ir-a";
export var hide = "_ir-9";
export var icon = "_ir-3";
export var input = "_ir-7";
export var inputFlex = "_ir-b";
export var inputWrapper = "_ir-c";
export var manualFocus = "_ir-5";
export var optionButton = "_ir-4";
export var pillWrapper = "_ir-e";
export var pointer = "_ir-2";
export var showOverflow = "_ir-f";
export var tagsFlex = "_ir-d";
export var xButton = "_ir-g";